import React, { useState } from 'react';
import { Turl } from '../components/tUrl.js';
import '../css/emailVerificationFlow.css'; // Стили остаются теми же
import { t } from 'ttag';
import { formatNumberWithCommas } from '../components/formatIntegerWithCommas.js';

const tg = window.Telegram ? window.Telegram.WebApp : null;

const sendTradeCode = async (amount) => {
    const _userData = tg ? tg.initData : null;
    let userData = { initData: _userData, amount: amount, type: 1 };

    const response = await fetch(Turl + '/st/send-trade-code', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userData),
    });
    return response.json();
};

const submitTradeDeposit = async (amount, code) => {
    const _userData = tg ? tg.initData : null;
    let userData = {
        initData: _userData,
        code: code,
        amount: parseFloat(amount)
    };

    const response = await fetch(Turl + '/st/trade-deposit', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
    });
    return response.json();
};

const Deposit = ({ recData }) => {
    const [step, setStep] = useState('enter_amount'); // 'enter_amount', 'enter_code', 'confirmed'
    // ‼️ УБРАЛИ СОСТОЯНИЕ EMAIL
    const [amount, setAmount] = useState('');
    const [code, setCode] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    // Переименовали handleEmailSubmit в handleAmountSubmit
    const handleAmountSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');

        const response = await sendTradeCode(amount);

        setIsLoading(false);
        if (response.success) {
            setStep('enter_code'); // Переходим к шагу ввода кода
        } else {
            setError(response.message || 'Не удалось отправить код. Попробуйте снова.');
        }
    };

    // Этот обработчик теперь отправляет данные без email
    const handleCodeSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');

        // ‼️ Вызываем новую функцию без email
        const response = await submitTradeDeposit(amount, code);

        setIsLoading(false);
        if (response.success) {
            setStep('confirmed');
            setTimeout(() => {
                window.location.reload(); // Обновляем страницу после успеха
            }, 1000);
        } else {
            setError(response.message || 'Ошибка. Неверный код или сумма.');
        }
    };

    // --- Рендеринг в зависимости от текущего шага ---

    if (step === 'confirmed') {
        return (
            <div className="Email-block">
                <div>
                    <h2 style={{ color: '#4cdf4c' }}>✓ Successfully!</h2>
                    {/* ‼️ УБРАЛИ EMAIL */}
                    <p>Your transfer of <strong>{amount} USDT</strong> is confirmed.</p>
                </div>
            </div>
        );
    }

    if (step === 'enter_code') {
        return (
            <div className="Email-block">
                <h2>Email Confirmation</h2>
                <p>
                    We sent a code to your registered email.<br />
                    You are sending <strong>{amount} USDT</strong>.
                </p>
                <form onSubmit={handleCodeSubmit}>
                    <div className='email-enter'>
                        <label htmlFor="code">Verification code:</label>
                        <input
                            type="text"
                            id="code"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            placeholder="123456"
                            required
                            disabled={isLoading}
                        />
                    </div>
                    <div className='email-enter'>
                        <button type="submit" disabled={isLoading || code.length < 6}>
                            {isLoading ? 'Checking...' : 'Confirm & Send'}
                        </button>
                    </div>
                    {error && <p className="error-text">{error}</p>}
                    <button
                        type="button"
                        onClick={() => { setStep('enter_amount'); setError(''); }}
                        className="link-button"
                    >
                        Change amount
                    </button>
                </form>
            </div>
        );
    }

    // --- Шаг 1: Ввод суммы ---
    return (
        <>
            {/* Блок Баланса */}
            <div className="f-balance-card">
                <div className="f-balance-label">{t`Balance`}</div>
                <div className="f-balance-value">{formatNumberWithCommas(recData.usdt, 0)} USDT</div>
            </div>

            <div className="Email-block">
                <h2>Enter the amount you want to send to the trade</h2>
                <p>We will send a confirmation code to your email.</p>
                <form onSubmit={handleAmountSubmit}>

                    <div className='email-enter'>
                        <label htmlFor="amount">Amount:</label>
                        <input
                            type="number"
                            id="amount"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            placeholder="100.00"
                            required
                            disabled={isLoading}
                        />
                    </div>

                    <div className='email-enter'>
                        <button
                            type="submit"
                            disabled={isLoading || !amount || parseFloat(amount) <= 0}
                        >
                            {isLoading ? 'Sending...' : 'Send code'}
                        </button>
                    </div>
                    {error && <p className="error-text">{error}</p>}
                </form>
            </div>
        </>
    );
};

export { Deposit };